import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import cn from "classnames";

const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/services", label: "Services" },
  { to: "/contact", label: "Contacts" },
];

const closeMobileMenu = () => {
  if (typeof document !== "undefined") {
    document.body.classList.remove("mobile-menu-visible");
  }
};

const MobileMenu = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const openBtns = document.querySelectorAll(".mobile-nav-toggler");
    const closeBtns = document.querySelectorAll(
      ".mobile-menu .close-btn, .menu-backdrop"
    );

    const open = () => document.body.classList.add("mobile-menu-visible");
    const close = () =>
      document.body.classList.remove("mobile-menu-visible");

    openBtns.forEach((b) => b.addEventListener("click", open));
    closeBtns.forEach((b) => b.addEventListener("click", close));

    return () => {
      openBtns.forEach((b) => b.removeEventListener("click", open));
      closeBtns.forEach((b) => b.removeEventListener("click", close));
    };
  }, []);

  // Close the menu when the user navigates
  useEffect(() => {
    closeMobileMenu();
  }, [pathname]);

  return (
    <>
      <div className="mobile-menu">
        <nav className="menu-box">
          <div className="close-btn" aria-label="Close menu">
            <i className="fas fa-times"></i>
          </div>

          <div className="nav-logo">
            <Link to="/" onClick={closeMobileMenu}>
              <img src="/img/logo/logo.svg" alt="FRG Renovation Works" />
            </Link>
          </div>

          <div className="menu-outer">
            <ul className="navigation">
              {NAV_LINKS.map((item) => (
                <li
                  key={item.to}
                  className={cn({ active: item.to === pathname })}
                >
                  <Link to={item.to} onClick={closeMobileMenu}>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="social-links">
            <ul className="clearfix list-wrap">
              <li>
                <a
                  href="https://www.facebook.com/share/p/1Hmopvbtwa/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/+601135160242"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="WhatsApp"
                >
                  <i className="fab fa-whatsapp"></i>
                </a>
              </li>
              <li>
                <a href="mailto:frgrenovationworks@gmail.com" aria-label="Email">
                  <i className="fas fa-envelope"></i>
                </a>
              </li>
              <li>
                <a href="tel:+601135160242" aria-label="Call">
                  <i className="fas fa-phone-alt"></i>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
      <div className="menu-backdrop"></div>
    </>
  );
};

export default MobileMenu;
